(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["vendor-featured-collection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vendor-featured-collection')) {
    customElements.define(
      'vendor-featured-collection',
      class extends HTMLElement {
        connectedCallback() {
          if (this.dataset.loaded === 'true') return;
          this.dataset.loaded = 'true';
          if ('IntersectionObserver' in window) {
            const observer = new IntersectionObserver((entries) => {
              if (!entries.some((entry) => entry.isIntersecting)) return;
              observer.disconnect();
              this.loadProducts();
            }, { rootMargin: '600px 0px' });
            observer.observe(this.closest('.shopify-section') || this);
          } else {
            this.loadProducts();
          }
        }

        async loadProducts() {
          try {
            const response = await fetch(this.dataset.url, { credentials: 'same-origin' });
            if (!response.ok) return;

            const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
            const productGrid = documentFragment.querySelector('.vendor-featured-collection__response');
            if (!productGrid) return;

            const currentProduct = this.dataset.currentProduct;
            productGrid.querySelector(`[data-product-handle="${CSS.escape(currentProduct)}"]`)?.remove();

            const limit = Number.parseInt(this.dataset.limit, 10);
            const items = [...productGrid.querySelectorAll('.vendor-featured-collection__item')];
            items.slice(limit).forEach((item) => item.remove());
            if (!productGrid.querySelector('.vendor-featured-collection__item')) return;

            const viewport = this.querySelector('.vendor-featured-collection__viewport');
            viewport.replaceChildren(productGrid);
            this.hidden = false;
            this.bindControls(viewport);
          } catch (error) {
            this.hidden = true;
          }
        }

        bindControls(viewport) {
          const controls = this.querySelector('.vendor-featured-collection__controls');
          const previous = controls.querySelector('[name="previous"]');
          const next = controls.querySelector('[name="next"]');
          const update = () => {
            controls.hidden = viewport.scrollWidth <= viewport.clientWidth + 1;
            previous.disabled = viewport.scrollLeft <= 1;
            next.disabled = viewport.scrollLeft + viewport.clientWidth >= viewport.scrollWidth - 1;
          };

          previous.addEventListener('click', () => viewport.scrollBy({ left: -viewport.clientWidth, behavior: 'smooth' }));
          next.addEventListener('click', () => viewport.scrollBy({ left: viewport.clientWidth, behavior: 'smooth' }));
          viewport.addEventListener('scroll', update, { passive: true });
          new ResizeObserver(update).observe(viewport);
          update();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
